/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcProspectusV1ProspectusJobState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PROSPECTUS_V1_PROSPECTUS_JOB_STATE_ENTITY_NAME = 'ixc.prospectus.v1.ProspectusJob';
export const ixcProspectusV1ProspectusJobStateEntity = new schema.Entity<IxcProspectusV1ProspectusJobState>(IXC_PROSPECTUS_V1_PROSPECTUS_JOB_STATE_ENTITY_NAME, {}, { idAttribute: 'jobId' });

